<template>
    <div class="ui button no border" v-if="active_button_to_detail_route_name"
        @click="show_core_wabill()">
        {{ next_button_content() }}
    </div>

    <div class="ui fluid buttons no border" v-else>
        <div class="ui labeled icon button no border "
            v-if="(eventbus.change_current_template.value == 'card' && is_show_change_template_btns) && !active_button_to_detail_route_name"
            @click="$bus.$emit(eventbus.change_current_template.name, 'min_card')">
            <i class="left chevron icon"></i>
            {{ (eventbus.change_current_template.value == 'card') ? '簡易模式' : '' }}
        </div>

        <div class="ui right labeled icon button no border"
            @click="show_core_wabill()"
            :style="{
                borderLeft: ((eventbus.change_current_template.value == 'card' && is_show_change_template_btns) && !active_button_to_detail_route_name)
                    ? '1px #252525 solid'
                    : ''
                }"
            >
            {{ next_button_content() }}
            <i class="right chevron icon" v-if="is_show_change_template_btns"></i>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },

        /*
         * 共用
         */
        is_show_change_template_btns: {
            default: false,
            type: Boolean
        },

        /*
         * template options
         */
        active_button_to_detail_route_name: {
            default: "",
            type: String
        },
    },
    data() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        show_core_wabill() {
            try {
                if (!this.core_waybill.identity) {
                    throw "請輸入號碼"
                }

                if (
                    this.active_button_to_detail_route_name != "" &&
                    (
                        this.$route.name != 'edit_core_waybill' ||
                        this.$route.name != 'customer_show_core_waybill'
                    )
                ) {
                    this.$router.push({
                        name: this.active_button_to_detail_route_name,
                        params: {
                            identity: this.core_waybill.identity
                        }
                    })
                } else {
                    var next_name = (this.eventbus.change_current_template.value == 'min_card') ? 'card' : 'detail'
                    this.$bus.$emit(this.eventbus.change_current_template.name, next_name)
                }

            } catch (err) {
                this.$noty.error(err)

            }
        },
        next_button_content() {
            var string = (this.eventbus.change_current_template.value == 'min_card')
                ? '檢視寄收資料'
                : '檢視完整資料'
            string = (this.active_button_to_detail_route_name) ? '檢視完整資料' : string
            string = (this.core_waybill.source_core_waybill) ? '有上層運單 無法編輯' : string

            return string
        },
    },
}
</script>

<style lang="scss" scoped>
    // 非常小的螢幕時, 如honeywell
    @media only screen and (max-width: 370px) {
        .buttons .ui.icon.button {
            padding-left: 0.5em !important;
            padding-right: 0.5em !important;
        }
    }
</style>
